<template>
  <div class="flex flex-wrap gap-2">
    <Button v-for="contextOption in options" :key="contextOption.value" class="gap-2" :variant="modelValue === contextOption.value ? 'default' : 'outline'" @click="emit('update:modelValue', contextOption.value)">
      <span>{{ contextOption.label }}</span>
      <span v-if="hasContextCount(contextOption)" class="rounded-full px-2 py-0.5 text-xs font-medium tabular-nums" :class="modelValue === contextOption.value ? 'bg-primary-foreground/20 text-primary-foreground' : 'bg-muted text-muted-foreground'">
        {{ contextOption.count }}
      </span>
    </Button>
  </div>
</template>

<script setup>
import { Button } from '../../../../../../../resources/js/components/ui/button/index.js'

defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  options: {
    type: Array,
    required: true,
  },
})

const emit = defineEmits(['update:modelValue'])

const hasContextCount = (contextOption) => {
  return contextOption.count !== undefined && contextOption.count !== null
}
</script>
